import { Card, CardContent, Grid } from '@mui/material';
import './card.css';
import { ICardDivider } from './ICardLine';

export default function CustomisedCardDivider({ part1, part2 }: ICardDivider) {
    return (
        <Card sx={{ background: "transparent !important" }} className="!shadow-none bg-[var(--input-bg-color)] ">
            <CardContent
                className="cardDivider !pb-0 "
                sx={{ fontWeight: 'normal' }}


            >
                <Grid container xs={12}>
                    <Grid
                        item
                        xs={12}
                        textAlign={'center'}
                        className="!pb-2 text-[var(--primary-text-color)]"
                    >
                        {part1}
                    </Grid>
                    {
                        part2 !== null && part2 !== undefined ?
                            <>
                                <Grid item xs={12}>
                                    <hr className="hrRequest" />
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    textAlign={'center'}
                                    className="!pt-3  text-[var(--primary-text-color)] "
                                    sx={{ paddingBottom: '1em !important' }}
                                >
                                    {part2}
                                </Grid></> : ''
                    }
                </Grid>
            </CardContent>
        </Card>
    );
}
